import PageSeo from "@/components/PageSeo";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import FeatureListSection from "@/components/sections/FeatureListSection";
import HeroSection from "@/components/sections/HeroSection";
import ProfileSection from "@/components/sections/ProfileSection";
import StatementSection from "@/components/sections/StatementSection";
import ValuesSection from "@/components/sections/ValuesSection";
import { aboutPageContent } from "@/content/pages/aboutPage";

export default function AboutPage() {
  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={aboutPageContent.seo} />
      <HeroSection content={aboutPageContent.hero} dataTestId="about-hero" />
      <StatementSection content={aboutPageContent.storySection} dataTestId="about-story" />
      <FeatureListSection content={aboutPageContent.audienceSection} dataTestId="about-audience" className="bg-muted/50" />
      <ProfileSection content={aboutPageContent.instructorSection} dataTestId="about-instructor" />
      <ValuesSection content={aboutPageContent.valuesSection} dataTestId="about-values" className="bg-muted/50" />
      <CtaBannerSection content={aboutPageContent.finalCta} dataTestId="about-cta" />
    </div>
  );
}
